module.exports = __webpack_public_path__ + "img/answer1-39.ca16714d.png";